import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { client } from './client';
import { AuthStoreProvider } from '@myaccountServices'

export const wrapRootElement = ({ element }) => (
  <AuthStoreProvider>
    <ApolloProvider client={client}>{element}</ApolloProvider>
  </AuthStoreProvider>
);
